import { ITradeNameByStoreDTO, ITradeNameDTO, ITradeNameViewDTO } from "../../../libs/coreapi-dto/dirs/tradeName";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";


interface ITradeNameCreate extends ITradeNameDTO {
}
interface ITradeNameUpdate extends ITradeNameDTO{
}

class TradeNameRequest extends BaseDirRequest<ITradeNameViewDTO, ITradeNameDTO> {

    constructor(baseUrl:string, token:string, eventHandler: IRequestEventHandler){
        super(baseUrl, "tradename", token, eventHandler)
    }

    create(body: ITradeNameCreate, callback: (e:CoreApiResponse<string>)=>void){
        super.create(body,callback)
    }

    update(idGlobal:string, body: ITradeNameUpdate, callback: (e:CoreApiResponse<null>)=>void){
        super.update(idGlobal,body,callback)
    }
        
    getDistinctViewByStore(body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<ITradeNameByStoreDTO>>) => void, signal?: AbortSignal | null) {        
        this.post<IViewWrapper<ITradeNameByStoreDTO>>(`${this._baseUrl}/${this._routePrefix}/DistinctViewByStore`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }, signal)
    }
}

export default TradeNameRequest